"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLive = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const utils_1 = require("../utils");
const WebSocket = global.WebSocket || require('ws');
class Observable extends rxjs_1.Observable {
    constructor(apiKey, url) {
        super((observer) => {
            this.observer = observer;
            this.init();
            return this.closeConnection;
        });
        this.apiKey = apiKey;
        this.url = url;
        this.init = async () => {
            var _a, _b, _c, _d;
            try {
                const url = new URL(this.url.replace('http', 'ws'));
                this.ws = new WebSocket(url);
                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.addEventListener('open', this.onOpen);
                (_b = this.ws) === null || _b === void 0 ? void 0 : _b.addEventListener('message', this.onMessage);
                (_c = this.ws) === null || _c === void 0 ? void 0 : _c.addEventListener('error', this.reconnect);
                (_d = this.ws) === null || _d === void 0 ? void 0 : _d.addEventListener('close', this.reconnect);
            }
            catch (_e) {
                await this.reconnect();
            }
        };
        this.onOpen = () => {
            this.ws.send(this.apiKey);
        };
        this.onMessage = (message) => {
            const json = JSON.parse(message.data);
            const func = Array.isArray(json) ? utils_1.processObjectArray : utils_1.processObject;
            this.observer.next(func(json));
        };
        this.reconnect = async () => {
            this.closeConnection();
            await new Promise((resolve) => setTimeout(resolve, interfaces_1.API_RETRY_TIMEOUT));
            this.init();
        };
        this.closeConnection = () => {
            var _a, _b, _c, _d, _e;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.removeEventListener('close', this.reconnect);
            (_b = this.ws) === null || _b === void 0 ? void 0 : _b.removeEventListener('error', this.reconnect);
            (_c = this.ws) === null || _c === void 0 ? void 0 : _c.removeEventListener('message', this.onMessage);
            if (((_d = this.ws) === null || _d === void 0 ? void 0 : _d.readyState) === 1) {
                (_e = this.ws) === null || _e === void 0 ? void 0 : _e.close();
            }
        };
    }
}
const fetchLive = (apiKey, url) => new Observable(apiKey, url).pipe((0, rxjs_1.shareReplay)({ refCount: true }));
exports.fetchLive = fetchLive;
